import {
  Persona,
  PersonaPresence,
  PersonaSize,
  PrimaryButton,
  TooltipHost,
  ITooltipHostProps,
} from "@fluentui/react";
import { useId } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IUser } from "../../Models/IUser";
import { GlobalState } from "../../Redux/RootReducer";
import { IRole } from "../../Models/IRole";
import { AppRoutes } from "../../Constants/AppRoutes";
import "./BetterPersona.scss";

const BetterPersona = () => {
  const navigate = useNavigate();
  const tooltipId = "user-tooltip-main-item";
  const user: IUser | undefined = useSelector(
    (s: GlobalState) => s.generic.user
  );

  const getUserInitials = () => {
    if (!user?.identifier) return "";

    const parts = user.identifier.includes(" ")
      ? user.identifier.split(" ")
      : user.identifier.split(".");
    return parts
      .map((part) => part[0]?.toLocaleUpperCase() || "")
      .slice(0, 2)
      .join("");
  };

  const roles =
    user?.roles?.map((role: IRole) => role.type.toUpperCase()) || [];

  const tooltipContent = (
    <div className="tooltip-content" onClick={(e) => e.stopPropagation()}>
      <div style={{ marginBottom: "1em" }}>
        <strong>{user?.identifier}</strong>
        <div>{roles.join(", ")}</div>
      </div>
      <PrimaryButton
        text="Impostazioni"
        onClick={(e) => {
          e.stopPropagation();
          navigate(AppRoutes.APP_OPTIONS_PAGE);
        }}
        iconProps={{ iconName: "Settings" }}
        styles={{ root: { marginBottom: "0.5em" } }}
      />
      <PrimaryButton
        text="Logout"
        onClick={(e) => {
          e.stopPropagation();
          navigate(AppRoutes.APP_LOGOUT_PAGE);
        }}
        iconProps={{ iconName: "OutOfOffice" }}
      />
    </div>
  );

  const tooltipProps: ITooltipHostProps = {
    content: tooltipContent,
    id: tooltipId,
    calloutProps: {
      gapSpace: 0,
      target: ".persona-wrap",
      isBeakVisible: true,
      setInitialFocus: true,
    },
    closeDelay: 100,
  };
  return (
    <div style={{ position: "relative" }}>
      <TooltipHost {...tooltipProps}>
        <div className="persona-wrap">
          <Persona
            imageInitials={getUserInitials()}
            text={user?.identifier}
            tertiaryText={roles.join(", ")}
            hidePersonaDetails
            size={PersonaSize.size32}
            presence={PersonaPresence.online}
          />
        </div>
      </TooltipHost>
    </div>
  );
};

export default BetterPersona;
